<template>
  <div :class="pageClass">
    <el-tabs type="border-card" tab-position="top" style="height:100%" v-model="activeName">
      <el-tab-pane label="基本信息" name="1">
        <el-form label-position="right" ref="ruleForm" :model="form" label-width="180px">
          <el-form-item>
            <label slot="label">头&nbsp;&nbsp;像</label>
            <el-upload
              class="avatar-uploader"
              action=" "
              :show-file-list="false"
              :http-request="submitUpload"
              accept=".jpg, .jpeg, .png, .JPG, .JPEG, .gif, .bmp"
            >
              <img v-if="form.avatar" :src="form.avatar" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="el-upload__tip">支持 .jpg、.gif、.jpeg、.png、.bmp 格式不超过5M</div>
          </el-form-item>
          <el-form-item
            prop="nickname"
            :rules="[{ pattern: /^[\u4E00-\u9FA5A-Za-z0-9_]{2,20}$/, max: 2,  message: '请输入正确的昵称（中文，字母、数字、下划线。2~20位）', trigger: 'blur' }]"
          >
            <label slot="label">昵&nbsp;&nbsp;称</label>
            <el-input maxlength="20" minlength="2" v-model="form.nickname" placeholder="请输入昵称"></el-input>
          </el-form-item>
          <el-form-item>
            <label slot="label">性&nbsp;&nbsp;别</label>
            <el-checkbox-group>
              <el-radio v-model="form.gender" :label="false">男</el-radio>
              <el-radio v-model="form.gender" :label="true">女</el-radio>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item>
            <label slot="label">用户名</label>
            <el-input v-model="form.name" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item
            label="真实姓名"
            prop="fullName"
            :rules="[{ pattern: /^[\u4E00-\u9FA5A-Za-z0-9_]{2,20}$/, message: '请输入姓名', trigger: 'blur' }]"
          >
            <el-input v-model="form.fullName"></el-input>
          </el-form-item>
          <!-- <el-form-item label="手机号">
            <el-input v-model="form.mobilePhone" placeholder="请输入手机号"></el-input>
            <el-button type="text">绑定</el-button>
          </el-form-item>
          <el-form-item label="微信号">
            <span>未绑定</span>
            <el-button type="text">绑定</el-button>
          </el-form-item>
          <el-form-item
            prop="email"
            :rules="[{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }]"
          >
            <label slot="label">邮&nbsp;&nbsp;箱</label>
            <el-input v-model="form.email" placeholder="填写邮箱可用于找回密码"></el-input>
          </el-form-item> -->
          <el-form-item
            label="请选择年级："
            prop="grade"
          >
            <el-select v-model="gradeId" placeholder="请选择">
              <el-option
                v-for="(item, index) in gradeArr"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="请选择学段："
            prop="term"
          >
            <el-select v-model="termId" placeholder="请选择">
              <el-option
                v-for="(item, index) in termArr"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmitInfo('ruleForm')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="修改密码" name="2">
        <el-form
          label-position="right"
          ref="ruleFormUploadPwd"
          :model="revisePwd"
          label-width="220px"
          :rules="rules"
        >
          <el-form-item
            label="请输入旧密码"
            prop="old_password"
          >
            <el-input v-model="revisePwd.old_password" show-password placeholder="请输入旧密码"></el-input>
            <el-button class="forget-password" @click="reterievePassword" type="text">忘记密码？</el-button>
          </el-form-item>
          <el-form-item
            label="请输入新密码"
            prop="passwordOne"
          >
            <el-input v-model="revisePwd.passwordOne" show-password placeholder="密码长度为6-20位"></el-input>
          </el-form-item>
          <el-form-item
            label="请再次输入新密码"
            prop="passwordTwo"
          >
            <el-input v-model="revisePwd.passwordTwo" show-password placeholder="密码长度为6-20位"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onRevisePwd('ruleFormUploadPwd')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="高考信息" name="3" v-if="curPath.indexOf('test.gk211985.com') != -1">
        <el-form label-position="right" label-width="180px" :model="gkInfo">
          <el-form-item label="省/直辖市/自治区">
            <el-cascader
              v-model="addressArr"
              :options="address"
              @change="addressChange">
            </el-cascader>
          </el-form-item>
          <el-form-item label="学科/文、理" prop="soa" v-if="gkType == 0">
            <el-radio-group v-model="gkInfo.soa">
              <el-radio label="0">理科</el-radio>
              <el-radio label="1">文科</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="学科/文、理" prop="checkList" v-if="gkType == 1">
            <el-checkbox-group class="grepSublect" v-model="gkInfo.checkList" :max="6">
              <el-checkbox label="9" disabled>语文</el-checkbox>
              <el-checkbox label="10" disabled>数学</el-checkbox>
              <el-checkbox label="11" disabled>英语</el-checkbox>
              <el-checkbox label="12">物理</el-checkbox>
              <el-checkbox label="13">化学</el-checkbox>
              <el-checkbox label="14">生物</el-checkbox>
              <el-checkbox label="17">政治</el-checkbox>
              <el-checkbox label="15">历史</el-checkbox>
              <el-checkbox label="16">地理</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="学校名称">
            <el-select v-model="gkInfo.schoolId" filterable placeholder="请选择学校或关键字搜索">
              <el-option :value="280894" label="软件服务中心"></el-option>
              <el-option v-for="(item, index) in schoolList" :value="item.id" :key="index" :label="item.schoolname"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="高考年份">
            <el-select v-model="gkInfo.examYear" placeholder="请选择年份">
              <el-option v-for="(year, index) in yearArr" :label="year" :value="year" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitGkInfo">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="账号绑定" name="4">
        <el-form label-position="right" label-width="180px">
          <el-form-item label="手机号">
            <span class="bind_text" v-if="!mobileIsDind">未绑定</span>
            <span class="bind_text" v-else>{{ wxMobile.mobile }}</span>
            <el-button class="bingBtn" type="text" v-if="!mobileIsDind" @click="dialogTableVisible = true">绑定</el-button>
            <el-button class="bingBtn" type="text" v-else @click="releveBindMobile">解绑</el-button>
          </el-form-item>
          <el-form-item label="微信号">
            <span class="bind_text" v-if="!wxIsDind">未绑定</span>
            <span class="bind_text" v-else>已绑定</span>
            <el-button class="bingBtn" type="text" v-if="!wxIsDind" @click="dialogWxVisible = true">绑定</el-button>
            <el-button class="bingBtn" type="text" v-else @click="releveBindWx">解绑</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="手机号绑定" :visible.sync="dialogTableVisible" custom-class="from" center :append-to-body="true">
        <div class="phone">
          <div class="content">
            <el-form
              status-icon
              label-width="0px"
              :model="wxMobile"
              class="demo-ruleForm"
              ref="wxMobile"
              :rules="ruleMobile"
            >
              <el-form-item prop="mobile">
                <el-input
                  v-model="wxMobile.mobile"
                  placeholder="请输入11位手机号码"
                  maxlength="11"
                ></el-input>
              </el-form-item>
              <el-form-item id="verify" prop="verify_code">
                <el-input
                  id="verify_text"
                  v-model="wxMobile.verify_code"
                  placeholder="请输入验证码"
                  onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  oninput="if(value.length>6)value=value.slice(0,6)"
                  autocomplete="off"
                ></el-input>
                <div
                  class="verify_code"
                  :style="{'color': isSend ? '#585858' : '#5c307d','cursor':isSend ? '':'pointer'}"
                  @click="getCode"
                >{{timing}}</div>
              </el-form-item>

              <el-button
                type="primary"
                :style="{'background-color': isDisabled ? '#585858' : '#5c307d','cursor':isDisabled ? '':'pointer'}"
                @click="bindMobileForm('wxMobile')"
                :disabled="isDisabled"
              >绑定</el-button>
            </el-form>
          </div>
        </div>
    </el-dialog>

    <el-dialog title="微信扫码绑定" center :visible.sync="dialogWxVisible" custom-class="wx" :append-to-body="true">
      <div class="content">
        <wxlogin
          class="ifam"
          :appid= "appid"
          :scope="'snsapi_login'"
          theme="white"
          :state="state"
          :redirect_uri="encodeURIComponent(bind_uri)"
          href="data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKIGRpc3BsYXk6IG5vbmU7Cn0KLmltcG93ZXJCb3ggewogbGluZS1oZWlnaHQ6MTsKfQouaW1wb3dlckJveCAucXJjb2RlIHsKIGJvcmRlcjogbm9uZTsKIHdpZHRoOiA2MyU7CiBtYXJnaW4tdG9wOjA7Cn0KLmltcG93ZXJCb3ggLnN0YXR1cyBwewogZm9udC1zaXplOjEycHg7Cn0KI3d4X2RlZmF1bHRfdGlwIHA6bGFzdC1jaGlsZHsKIGRpc3BsYXk6bm9uZTsKfQouaW1wb3dlckJveCAuaW5mb3sKIGRpc3BsYXk6bm9uZTsKIGhlaWdodDozMHB4Owogd2lkdGg6IDE0OHB4OwogbWFyZ2luOiAtMTFweCBhdXRvICFpbXBvcnRhbnQ7Cn0KLmltcG93ZXJCb3ggLnN0YXR1c3sKIGRpc3BsYXk6bm9uZTsKIHBhZGRpbmc6MDsKfQouaW1wb3dlckJveCAuc3RhdHVzewogY29sb3I6IzYyNmI4MDsKfQoud3JwX2NvZGV7CiBoZWlnaHQ6NjElOwp9Ci5pbXBvd2VyQm94IC5pbmZvIC5zdGF0dXN7CmhlaWdodDozMHB4Owpmb250LXNpemU6MTJweDsKfQouaW1wb3dlckJveCAuc3RhdHVzIC5zdGF0dXNfdHh0IHB7CiBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5pY29uMzhfbXNnLnN1Y2N7CiAgYmFja2dyb3VuZC1zaXplOiAyMHB4OwogIGJhY2tncm91bmQtcG9zaXRpb246IDAgLTIxcHg7Cn0KLmltcG93ZXJCb3ggLmljb24zOF9tc2d7CiB3aWR0aDoyNXB4OwogaGVpZ2h0OjI1cHg7Cn0KLmltcG93ZXJCb3ggLmljb24zOF9tc2cud2FybnsKICBiYWNrZ3JvdW5kLXNpemU6IDIwcHg7CiAgYmFja2dyb3VuZC1wb3NpdGlvbjogMCAtNDRweDsKfQ"
        ></wxlogin>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import wxlogin from "@/components/wx-login/wx-login.vue";
import address from '@/assets/js/address'
export default {
  data() {
    let space = /\s/
    // var reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
    let valid_no_chinese = /^[^\u4e00-\u9fa5]+$/g;
    var pass_valid = (rule, value, callback) => {
      if(value.match(space)){
        callback(new Error("密码不能包含空格!"));
      } else if (!value.match(valid_no_chinese)) {
        callback(new Error("密码不能包含中文!"));
      }else{
        callback();
      }
    }
    let phone_valid = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
    let phone_is_nan = (rule, value, callback) => {
      if(!value.match(phone_valid)){
        callback(new Error("不是一个手机号!"));
      }else{
        this.$HTTP
        .executeGet(this.$APIS.MOBILE_IS_BINDING + '/'+ value, this)
        .then((res) => {
          if (res.code) {
            callback(new Error("手机号已绑定!"))
          } else {
            callback()
          }
        })
      }
    };
    return {
      curPath: '',
      addressArrlength: 0,
      schoolList: [],
      addressArr: [],
      address,
      provinceId: null,
      cityId: null,
      countyId: null,

      gradeArr: [],
      termArr: [],
      gradeId: null, //年级id
      termId: null, //学段id
      code: '',
      activeName: '1',
      appid : this.$config.wxInfo.appid,
      isSend: false,
      isDisabled: false,
      timing: "获取验证码",
      bind_uri : this.$config.wxInfo.bind_uri,
      ruleMobile: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '手机号码长度11', trigger: 'blur' },
          { validator: phone_is_nan, trigger: 'blur' },
        ],
        verify_code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      dialogTableVisible: false,
      wxMobile: {
        mobile: '',
        verify_code: ''
      },
      mobileIsDind: false,
      wxIsDind: false,
      generate_verify_code: '',
      countdown: 60,
      dialogWxVisible: false,
      pageClass: "setting",
      form: {},
      revisePwd: {
        old_password: "",
        passwordOne: "",
        passwordTwo: "",
      },
      revisePwdParams: {
        user_id: "",
        old_password: "",
        password: "",
      },
      userInfo: {},
      gkType: 1,
      gkInfo: {
        schoolId: null,
        school: "", // 学校
        province: "", // 省份
        subjectIds: "",
        soa: "0",
        checkList: [],
        examYear: 2021,
      },
      gkParams: {
        subjectIds: "",
        examYear: ""
      },
      yearArr: [],
      rules: {
        old_password: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码长度为6-20", trigger: "blur" },
          { validator : pass_valid,trigger: "blur"}
        ],
        passwordOne: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码长度为6-20", trigger: "blur" },
          { validator : pass_valid,trigger: "blur"}
        ],
        passwordTwo: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码长度为6-20", trigger: "blur" },
          { validator : pass_valid,trigger: "blur"}
        ],
      }
    };
  },
  components: {
    wxlogin
  },
  methods: {
    addressChange (val) {
      this.addressArrlength = val.length
      this.getTypeByProv(val[0])
      this.gkInfo.schoolId = 280894
      if (!this.addressArrlength) {
        this.provinceId = null
      } else if (this.addressArrlength === 1) {
        this.provinceId = val[0]
        this.getSchoolList({ provinceId: this.provinceId })
      } else if (this.addressArrlength === 2) {
        this.provinceId = val[0]
        this.cityId = val[1]
        this.getSchoolList({ cityId: this.cityId })
      } else {
        this.provinceId = val[0]
        this.cityId = val[1]
        this.countyId = val[2]
        this.getSchoolList({ countyId: this.countyId })
      }
    },
    getTypeByProv(val) {
      this.$HTTP
        .executeGet(this.$APIS.GET_TYPE_BY_PROVINCE + val, this)
        .then((response) => {
          this.gkType = response.gkType;
        });
    },
    // 获取学校接口
    getSchoolList (data) {
      this.$HTTP
        .executePost(this.$APIS.GET_SCHOOL, data, this)
        .then((res) => {
          if (res.code === 0) {
            this.schoolList = res.data
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 获取年级
    getAllGrade() {
      this.$HTTP
        .executeGet(this.$APIS.GET_ALL_GRADE, this)
        .then((response) => {
          if (response.code === 0) {
            this.gradeArr = response.data
          } else {
            this.$message.error(response.msg)
          }
        });
    },
    // 获取学段
    getAllTerm() {
      this.$HTTP
        .executeGet(this.$APIS.GET_ALL_TERM, this)
        .then((response) => {
          if (response.code === 0) {
            this.termArr = response.data
          } else {
            this.$message.error(response.msg)
          }
        });
    },
    releveBindWx() {
      this.$confirm('此操作将不能使用手机微信扫码登录, 是否继续?', '解绑微信号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$HTTP
        .executeGet(this.$APIS.RELIEVE_BIND_WX, this)
        .then((response) => {
          if (response.code === 0) {
            this.$message.success('解绑成功')
            this.wxIsDind = false
          } else {
            this.$message.error(response.msg)
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解绑'
        })
      })
    },
    // 解绑手机号
    releveBindMobile() {
      this.$confirm('此操作将不能使用手机号登录, 是否继续?', '解绑手机号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$HTTP
        .executeGet(this.$APIS.RELIEVE_BIND + this.wxMobile.mobile, this)
        .then((response) => {
          if (response.code === 0) {
            this.$message.success('解绑成功')
            this.mobileIsDind = false
            let userinfo = localStorage.getItem("userinfo");
            const user = JSON.parse(userinfo);
            user.mobilePhone = ''
            let setUser = JSON.stringify(user)
            localStorage.setItem("userinfo", setUser);
          } else {
            this.$message.error(response.msg)
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解绑'
        })
      })
    },
    // 绑定手机号
    bindMobileForm(name) {
      this.$refs[name].validate((valid) => {
        if(valid) {
          let params = {
            mobile: this.wxMobile.mobile,
            "verify-code": this.wxMobile.verify_code,
          }
          this.$HTTP
            .executePost(this.$APIS.SET_BIND_MOBILE, params, this)
            .then((response) => {
              if (response.code === 0) {
                this.$message.success('绑定手机号成功')
                this.mobileIsDind = true
                this.dialogTableVisible = false
                this.isSend = false;
                // 手机号存 sessioin
                let userinfo = localStorage.getItem("userinfo");
                const user = JSON.parse(userinfo);
                user.mobilePhone = this.wxMobile.mobile
                let setUser = JSON.stringify(user)
                localStorage.setItem("userinfo", setUser);
              } else {
                this.$message.error(response.msg)
                this.isSend = false;
              }
            });
        } else {
          this.$message.error('请检查输入是否正确')
        }
      })
      
    },
    getCode() {
      // 获取验证码
      if (this.countdown != 60) return;
      if (!this.isSend) {
        this.isSend = true;
        //生成一个6位数的验证码
        this.generate_verify_code = Math.random().toString().substring(2, 8);
        //发送请求
        let data = {
          mobile: this.wxMobile.mobile,
          "verify-code": this.generate_verify_code,
        };
        this.$HTTP
          .executePost(this.$APIS.GET_MOBILE_IS_BINDING, data, this)
          .then((response) => {
            if (response.msg == "Success!") {
              this.$message.success("获取验证码成功!");
              //验证码有效期为十分钟,存到store中,设置有效期
              let code = {
                very_code: this.generate_verify_code,
                time_end: new Date().getTime() + 10 * 60 * 1000,
              };
              window.localStorage.setItem(
                "register_code",
                JSON.stringify(code)
              );
              if (!this.timer) {
                this.timer = setInterval(() => {
                  if (this.countdown >= 0 && this.countdown <= 60) {
                    this.countdown--;
                    if (this.countdown >= 0) {
                      this.timing = this.countdown + "s";
                    } else {
                      clearInterval(this.timer);
                      this.timing = "获取验证码";
                      this.countdown = 60;
                      this.isSend = false;
                    }
                  }
                }, 1000);
              }
            } else {
              this.$message.error("获取验证码失败!");
              this.isSend = false;
            }
          });
      }
    },
    // 修改基础信息
    onSubmitInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            avatar: this.form.avatar,
            email: this.form.email,
            userId: this.form.id,
            gender: this.form.gender,
            nickname: this.form.nickname,
            fullName: this.form.fullName,
            gradeId: this.gradeId,//年级id
            termId:  this.termId//学段id
          };
          this.$HTTP
            .executePost(this.$APIS.SET_RENEW_USER_BASIC_INFO, params, this)
            .then((res) => {
              let code = res.code;
              if (!code) {
                this.$message.success("修改用户信息成功");
                localStorage.setItem("userinfo", JSON.stringify(this.form));
                this.$root.eventHub.$emit("updata-user-info");
              } else {
                this.$message.error(res.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    // 修改密码
    onRevisePwd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.revisePwd.passwordOne != this.revisePwd.passwordTwo) {
            this.$message.error("两次输入密码不一致");
            return false;
          }

          this.revisePwdParams.password = this.revisePwd.passwordOne;
          this.revisePwdParams.old_password = this.revisePwd.old_password;
          this.revisePwdParams.user_id = this.form.id;

          this.$HTTP
            .executePost(this.$APIS.SET_PASSWORD, this.revisePwdParams, this)
            .then((res) => {
              if (!res.code) {
                this.$message({
                  type: 'success',
                  message: '修改密码成功',
                  duration: 2000
                })
                this.revisePwd.passwordOne = "";
                this.revisePwd.passwordTwo = "";
                this.revisePwd.old_password = "";
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg,
                  duration: 2000
                })
              }
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '请求数据失败',
                duration: 2000
              })
            });

        } else {
          return false;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    submitUpload(file) {
      const isLt2M = file.file.size / 1024 / 1024 < 5;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
        return false;
      }

      const formData = new FormData();
      formData.append("file", file.file);
      this.$axios
        .post(this.$APIS.GET_USER_ANSWER_FILES_PATH, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success("上传成功");
            this.form.avatar = `${ this.$config.backURL }${res.data.data}`;
            this.$root.eventHub.$emit('updata-user-avatar', this.form.avatar);
          } else {
            this.$message.success(res.msg);
          }
        })
        .catch(() => {
          this.$message.warning("上传失败");
          this.loading = false;
        });
    },
    submitGkInfo() {
      this.gkParams.schoolId = this.gkInfo.schoolId || 280894;
      this.gkParams.provinceId = this.provinceId;
      this.gkParams.cityId = this.cityId;
      this.gkParams.countyId = this.countyId;
      this.gkParams.examYear = this.gkInfo.examYear;
      if (!this.gkType) {
        if (this.gkInfo.soa == 0) {
          this.gkParams.subjectIds = "9,10,11,12,13,14";
        } else {
          this.gkParams.subjectIds = "9,10,11,15,16,17";
        }
      } else {
        this.gkParams.subjectIds = this.gkInfo.checkList.join(",");
      }

      this.$HTTP
        .executePost(this.$APIS.SET_USER_GK_INFO, this.gkParams, this)
        .then((res) => {
          let code = res.code;
          if (!code) {
            this.$message({
              type: 'success',
              message: '修改用户信息成功',
              duration: 2000
            })
            this.form.schoolId = this.gkParams.schoolId;
            this.form.provinceId = this.provinceId;
            this.form.cityId = this.cityId;
            this.form.countyId = this.countyId;
            this.form.subjectIds = this.gkParams.subjectIds;
            this.form.examYear = this.gkParams.examYear;
            this.form.schoolId = this.
            localStorage.setItem("userinfo", JSON.stringify(this.form));
            this.$root.eventHub.$emit("updata-user-info");
          } else {
            this.$message({
              type: 'error',
              message: res.msg,
              duration: 2000
            })
          }
        });
    },
    reterievePassword() {
      if (this.mobileIsDind) {
        this.$router.push({
          path: '/reterieve_password'
        })
      } else {
        this.$message({
          message: '请先绑定手机号，通过手机号找回密码!',
          type: 'warning'
        })
      }
    }
  },
  created() {
    this.getAllTerm()
    this.getAllGrade()
    this.curPath = window.location.hostname;
    this.activeName = this.$route.query.active_name || '1'
    let userinfo = localStorage.getItem("userinfo");
    const user = JSON.parse(userinfo);
    this.form = user;
    this.gradeId = user.gradeId || null
    this.termId = user.termId || null
    this.gkInfo.schoolId = user.schoolId || 280894;
    this.gkInfo.provinceId = user.provinceId;
    this.gkInfo.examYear = user.examYear;
    this.gkInfo.checkList = user.subjectIds.split(",");

    if (user.provinceId) {
      this.provinceId = user.provinceId
      this.addressArr.push(user.provinceId)
    }
    if (user.cityId) {
      this.cityId = user.cityId
      this.addressArr.push(user.cityId)
    }
    if (user.countyId) {
      this.countyId = user.countyId
      this.addressArr.push(user.countyId)
    }
    if (this.addressArr.length === 1) {
      this.$HTTP
        .executePost(this.$APIS.GET_SCHOOL, { provinceId: user.provinceId }, this)
        .then((res) => {
          if (res.code === 0) {
            this.schoolList = res.data
            this.gkInfo.schoolId = user.schoolId || 280894
            this.schoolList.push({
              value: user.schoolId,
              label: user.schoolName
            })
          } else {
            this.$message.error(data.msg)
          }
        })
    }
    if (this.addressArr.length === 2) {
      this.$HTTP
        .executePost(this.$APIS.GET_SCHOOL, { cityId: user.cityId }, this)
        .then((res) => {
          if (res.code === 0) {
            this.schoolList = res.data
            this.gkInfo.schoolId = user.schoolId || 280894
            this.schoolList.push({
              value: user.schoolId,
              label: user.schoolName
            })
          } else {
            this.$message.error(data.msg)
          }
        })
    }
    if (this.addressArr.length === 3) {
      this.$HTTP
        .executePost(this.$APIS.GET_SCHOOL, { countyId: user.countyId }, this)
        .then((res) => {
          if (res.code === 0) {
            this.schoolList = res.data
            this.gkInfo.schoolId = user.schoolId
            this.schoolList.push({
              value: user.schoolId,
              label: user.schoolName
            })
          } else {
            this.$message.error(data.msg)
          }
        })
    }

    this.wxMobile.mobile = user.mobilePhone
    if (this.wxMobile.mobile) {
      this.mobileIsDind = true
    }

    this.$HTTP
      .executeGet(this.$APIS.GET_WX_BIND, this)
      .then((res) => {
        if(res.code == 0) {
          this.wxIsDind = false
        } else if (res.code  == 2) {
          this.wxIsDind = true
        } else {
          this.$message.error(res.msg)
        }
      })

    // 高考日期动态计算
    let date = new Date();
    let nowTime = date.getTime();
    let year = date.getFullYear();
    let dateTime = new Date(year, 5, 7).getTime();
    year = nowTime > dateTime ? ++year : year;
    for (let i = 0; i < 3; i++) {
      this.yearArr.push(year++);
      console.log('this.yearArr', this.yearArr)
    }

    // 微信登陆新增

    // console.log('window.location.href.substr(1)', window.location.href.substr(1))
    // this.code = window.location.href.substr(1).split('&')[0].split('=')[1]
    let codes = window.location.href.substr(1).split('&')
    if(codes != null && codes.length) {
      for (let index = 0; index < codes.length; index++) {
        const element = codes[index].split('=')[1];
        if (element.length > 5) {
          this.code = element
          if (this.code) { // 有值 表示微信绑定
            // this.$store.commit('changeIsShowLogin', false);
            this.$HTTP
              .executePost(this.$APIS.SET_WX_BIND, {code: this.code},  this)
              .then((response) => {
                if(response.code == 0) {
                  // 绑定成功
                  this.$message.success('绑定成功')
                  this.wxIsDind = true
                } else {
                  this.$message.error(response.msg)
                }
              })
          }
        }
      }
    }
  }
};
</script>
<style scoped lang="stylus">
.bind_text {
  line-height: 50px;
  color: #aaa;
}
.bingBtn {
  position: absolute;
  right: 20px;
  top: 0;
}
/deep/ .el-input__inner {
  height: 32px;
  font-size: 20px;
  width: 336px;
  border-radius: 26px;
  background: #f7f7f7;
}
.setting {
  height: auto;
  background-color: #fff;

  .el-tabs--border-card {
    background: none;
    border: none;
    box-shadow: none;
  }

  /deep/ .el-tabs {
    width: 100%;
    height: auto;
    position: relative;

    .el-tabs--border-card {
      border: none;
      box-shadow: none;
    }

    .el-tabs__item {
      font-size: 18px;
      padding: 0 95px !impontent;
      color: #5c307d;
      height: 50px;
      line-height: 50px;
    }

    .el-tabs__item:last-child {
      padding: 0 95px;
    }

    .el-tabs__item:first-child {
      padding: 0 95px;
    }

    .el-tabs__item:nth-child(2) {
      padding: 0 95px;
    }

    .el-tabs__item:nth-child(3) {
      padding: 0 95px;
    }

    .el-tabs__nav-wrap::after {
      background-color: #ffffff;
    }

    .el-tabs__item.is-active {
      color: #ffffff;
      background-color: #5c307d;
    }

    .el-tabs__header {
      background-color: #fff;
      border-bottom: 1px solid #ddd;
    }

    .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
      color: #ffffff;
      background-color: #5c307d;
    }

    .el-tabs__content {
      // padding: 0;
      // position: absolute;
      // background: #ffffff;
      // top: 50px;
      // bottom: 0px;
      // left: 0;
      // right: 0;
      // overflow-y: auto;
    }

    .el-form-item__error {
      left: 45px;
    }
  }

  /deep/ .el-form {
    margin-top: 50px;
    padding-left: 150px;

    .el-form-item {
      margin-bottom: 20px;
    }

    .el-checkbox-group {
      width: 280px;
      margin-left: 35px;
    }

    .el-radio-group {
      margin-left: 35px;
    }

    .el-form-item__label {
      font-size: 20px;
      color: #aaaaaa;
      margin-top: 5px;
    }

    .avatar-uploader {
      margin-left: 30px;
    }

    .el-upload__tip {
      margin-left: 30px;
    }

    .el-form-item__content {
      margin-left: 330px !impontant;
      width: 336px;
      .getcode {
        position: relative;
        float: left;
        padding-left: 10px;
        padding-top: 2px;
        font-size: 18px;
      }
    }
    .forget-password {
      position: absolute;
      font-size: 18px;
      right: -150px;
      top: 3px;
    }

    /deep/ .el-checkbox-group {
      margin-left: 60px;
    }

    .el-upload__tip {
      width: 500px;
      color: #aaaaaa;
    }

    .el-button {
      margin-left: 30px;
    }

    .el-input__inner {
      height: 42px;
      font-size: 20px;
      width: 336px;
      border-radius: 26px;
      background: #f7f7f7;
    }

    .el-input {
      margin-left: 30px;
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 65px;
      height: 65px;
      line-height: 65px;
      text-align: center;
    }

    .avatar {
      width: 65px;
      height: 65px;
      display: block;
    }

    .el-radio__label {
      font-size: 20px;
    }

    .el-button--primary {
      height: 52px;
      font-size: 20px;
      width: 336px;
      border-radius: 26px;
      border: none;
      background: #5c307d;
      color: #ffffff;
    }

    .el-input--suffix {
      width: 336px;
    }
  }
}
</style>
<style lang="scss" scoped>

/deep/ .from {
  width: 420px;
  height: 415px;
  .el-dialog__body {
    padding: 0px;
    .el-input {
      text-align: center;
    }

    .el-input__inner {
      height: 50px;
      font-size: 16px;
    }
  }
  .phone {
  width: 420px;
  height: 415px;
  position: relative;
  float: left;


  .content {
    width: 420px;
    height: 265px;
    position: relative;
    float: left;
    top: 30px;

    .el-form-item {
      margin-left: 50px;
      width: 337px;
      height: 48px;
      position: relative;
      margin-top: 30px;

      .el-form-item__content {
        width: 337px;
        height: 48px;
        position: relative;
        float: left;

        .el-input {
          width: 337px;
          height: 48px;
          float: left;
          position: relative;

          input {
            background-color: #f7f7f7;
            border-radius: 50px;
            height: 48px;
            font-size: 16px;
            color: #585858;
            float: left;
            position: relative;
          }

          .el-icon-circle-check {
            color: green;
          }
        }
      }
    }

    #verify {
      margin-left: 50px;
      width: 337px;
      height: 48px;
      position: relative;
      float: left;
      margin-top: 8px;

      .el-input {
        width: 217px;
        height: 48px;
        float: left;
        position: relative;

        input {
          background-color: #f7f7f7;
          border-radius: 50px;
          height: 48px;
          font-size: 16px;
          width: 217px;
          border-radius: 50px 0px 0px 50px;
          float: left;
        }

        .el-icon-circle-check {
          color: green;
        }
      }

      .verify_code {
        position: relative;
        background-color: #f7f7f7;
        width: 120px;
        border-radius: 0px 50px 50px 0px;
        height: 48px;
        line-height: 45px;
        font-size: 16px;
        border: 1px #dcdfe6 solid;
        border-left: none;
        color: #5c307d;
        float: left;
        text-align: center;
        cursor: pointer;
      }
    }

    .el-button {
      position: relative;
      float: left;
      width: 337px;
      height: 50px;
      text-align: center;
      background-color: #5c307d;
      border-radius: 50px;
      font-size: 20px;
      color: #ffffff;
      margin-top: 8px;
      margin-left: 51.5px;
    }
  }

  .mode {
    width: 420px;
    height: 40px;
    position: relative;
    float: left;

    .left {
      height: 40px;
      position: relative;
      float: left;
      text-align: center;
      font-size: 16px;
      color: #626b80;
      margin-left: 50px;
      cursor: pointer;
    }

    .center {
      float: left;
      margin-left: 85px;
      cursor: pointer;
      font-size: 16px;
      color: #626b80;
    }

    .right {
      height: 40px;
      position: relative;
      text-align: center;
      float: right;
      font-size: 16px;
      color: #626b80;
      margin-right: 30px;
      cursor: pointer;
    }
  }

  .bottom {
    width: 420px;
    height: 60px;
    position: relative;
    float: left;

    .wxbtn {
      height: 60px;
      width: 60px;
      position: relative;
      float: right;

      img {
        height: 60px;
        width: 60px;
      }
    }
  }
}
}

</style>

<style lang="scss" scoped>
/deep/ .wx {
  width: 400px;
  height: 350px;
  .el-dialog__body {
    padding: 0px;
    .el-input {
      text-align: center;
    }

    .el-input__inner {
      height: 50px;
      font-size: 16px;
    }
  }
  .content {
    width: 400px;
    height: 415px;
    .ifam {
      width: 100% !important;
    }
  }
}
</style>